import { useRef, useState, useLayoutEffect } from 'react';

import { Flex, VStack } from '@vimeo/bokeh';

import { ShimmeringPlaceholder } from '../ShimmeringPlaceholder';

export const AskQuestionPanel = () => {
  const [offset, setOffset] = useState<number | undefined>();
  const containerRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    setOffset(containerRef.current?.offsetWidth);
  }, []);

  return (
    <Flex
      ref={containerRef}
      w="100%"
      h="100%"
      p="16px"
      flexDirection="column"
      justifyContent="space-between"
      data-testid="ask-question-panel"
    >
      <VStack gap="8px" w="100%" alignItems="flex-start">
        <ShimmeringPlaceholder h="16px" w="70%" maxWidth={offset} bgOffset={15} />
        <ShimmeringPlaceholder h="16px" w="100%" maxWidth={offset} bgOffset={30} />
        <ShimmeringPlaceholder h="16px" w="70%" maxWidth={offset} bgOffset={45} />
        <ShimmeringPlaceholder h="16px" w="60%" maxWidth={offset} bgOffset={60} />
      </VStack>
    </Flex>
  );
};
